import { PERMISSIONS, ROUTE_PATHS } from "../PermissionsConstants";
import {
  NewspaperIcon,
  QrCodeIcon,
  BuildingOfficeIcon,
  UsersIcon,
  EnvelopeIcon,
  UserIcon,
  CreditCardIcon,
  UserGroupIcon,
  ServerStackIcon,
  ShieldCheckIcon,
  PrinterIcon,
  BriefcaseIcon,
  IdentificationIcon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  BuildingStorefrontIcon,
} from "@heroicons/react/24/solid";
import UserModuleandRoleMgt from "./UserModuleandRoleMgt";
import EmailRecipientConfiguration from "./EmailRecipientConfiguration";
import Entity from "./Entity";
import ConfigureAgreement from "./ConfigureAgreement";
import PolicyTerm from "./PolicyTerms";
import ProducerConfiguration from "./ProducerConfiguration";
import EmployeeConfiguration from "./EmployeeConfiguration";
import SecurityConfiguration from "./SecurityConfiguration";
import GroupConfiguration from "./GroupConfiguration";
import Office from "./Office";
import ExecuteQuery from "./ExecuteQuery";
import LeasedEquipmentConfiguration from "./LeasedEquipmentConfiguration";
import Jobs from "./Jobs";
import BusinessLicencesPermits from "./BusinessLicensesPermitsConfiguration";
import { ScriptConfiguration } from "./ScriptConfiguration";
import DigitalAssetsConfiguration from "./DigitalAssetsConfiguration";
import { CustomReport } from "./CustomReport";
import VendorConfiguration from "./VendorConfiguration";
import OfficeAppliances from "./OfficeAppliances";

export const UtilitiesTabs = [
  {
    to: ROUTE_PATHS.Utilities_UserManagement_Index,
    icon: <UserIcon className="h-4 w-4 mr-2" />,
    title: "User Role",
    label: (
      <div>
        <div className="truncate text-left">User Role</div>
      </div>
    ),

    component: UserModuleandRoleMgt,
    permission: PERMISSIONS.permission_utilities_userrolemanagement_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmailRecipient_Index,
    icon: <EnvelopeIcon className="h-4 w-4 mr-2 " />,
    title: "Email Recipient",
    label: (
      <div>
        <div className="truncate text-left"> Email Recipient</div>
      </div>
    ),
    component: EmailRecipientConfiguration,
    permission:
      PERMISSIONS.permission_utilities_emailrecipientconfiguration_view,
  },
  {
    to: ROUTE_PATHS.Utilities_LeasedEquipmentConfiguration_Index,
    icon: <PrinterIcon className="h-4 w-4 mr-2" />,
    title: "Leased Equipment",
    label: (
      <div>
        <div className=" text-left"> Leased Equipment</div>
      </div>
    ),
    component: LeasedEquipmentConfiguration,
    permission: PERMISSIONS.permission_utilities_leasedconfiguration_view,
  },
  {
    to: ROUTE_PATHS.Utilities_Entity_Index,
    icon: <ServerStackIcon className="h-4 w-4 mr-2" />,
    title: "Entity",
    label: (
      <div>
        <div className="truncate text-left"> Entity</div>
      </div>
    ),
    component: Entity,
    permission: PERMISSIONS.permission_utilities_entity_view,
  },
  {
    to: ROUTE_PATHS.Utilities_configureagreement_Index,
    icon: <NewspaperIcon className="h-4 w-4 mr-2 " />,
    title: "Agreement",
    label: (
      <div>
        <div className="truncate text-left"> Agreement</div>
      </div>
    ),
    component: ConfigureAgreement,
    permission: PERMISSIONS.permission_utilities_configureagreement_view,
  },
  {
    to: ROUTE_PATHS.Utilities_PolicyTerm_Index,
    component: PolicyTerm,
    title: "Policy Fee",
    label: (
      <div>
        <div className="truncate text-left"> Policy Fee</div>
      </div>
    ),
    icon: <CreditCardIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_policyterm_view,
  },

  {
    to: ROUTE_PATHS.Utilities_Office_Index,
    component: Office,
    title: "Office",
    label: (
      <div>
        <div className="truncate text-left"> Office</div>
      </div>
    ),
    icon: <BuildingOfficeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_officeconfiguration_view,
  },
  {
    to: ROUTE_PATHS.Utilities_ProducerConfiguration_Index,
    component: ProducerConfiguration,
    title: "Producer Code",
    label: (
      <div>
        <div className="truncate text-left"> Producer Code</div>
      </div>
    ),
    icon: <QrCodeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_producerconfiguration_view,
  },

  {
    to: ROUTE_PATHS.Utilities_EmployeeType_Index,
    component: EmployeeConfiguration,
    title: "EmployeeConfiguration",
    label: (
      <div>
        <div className="truncate text-left"> Employee</div>
      </div>
    ),
    icon: <UsersIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_employeetype_view,
  },

  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_Index,
    component: SecurityConfiguration,
    title: "SecurityConfiguration",
    label: (
      <div>
        <div className="truncate text-left"> Security</div>
      </div>
    ),
    icon: <ShieldCheckIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_securityconfiguration_view,
  },

  {
    to: ROUTE_PATHS.Utilities_OperationsGroup_Index,
    component: GroupConfiguration,
    title: "OperationsGroup",
    label: (
      <div>
        <div className="truncate text-left"> Operations Group</div>
      </div>
    ),
    icon: <UserGroupIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_operationsgroup_view,
  },
  {
    to: ROUTE_PATHS.Utilities_BusinessLicensesPermits_Type_Index,
    component: BusinessLicencesPermits,
    label: (
      <div>
        <div className="truncate text-left"> Business Licenses </div>
      </div>
    ),
    icon: <IdentificationIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_utilities_businesslicensespermitsconfiguration_type_view,
  },
  {
    to: ROUTE_PATHS.Utilities_ExecuteQuery_Index,
    component: ExecuteQuery,
    label: (
      <div>
        <div className="truncate text-left"> Execute Query</div>
      </div>
    ),
    icon: <CreditCardIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_executequery_view,
  },

  {
    to: ROUTE_PATHS.Utilities_JobConfiguration_Index,
    component: Jobs,
    label: (
      <div>
        <div className="truncate text-left"> Job </div>
      </div>
    ),
    icon: <BriefcaseIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_jobconfiguration_view,
  },

  {
    to: ROUTE_PATHS.Utilities_ScriptConfiguration_Index,
    component: ScriptConfiguration,
    label: (
      <div>
        <div className="truncate text-left"> Script </div>
      </div>
    ),
    icon: <DocumentTextIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_scriptconfiguration_view,
  },
  {
    to: ROUTE_PATHS.Utilities_DigitalAssets_OnlineDirectories_Index,
    component: DigitalAssetsConfiguration,
    label: (
      <div>
        <div className="truncate text-left"> Digital Assets </div>
      </div>
    ),
    icon: <PresentationChartLineIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_utilities_digitalassets_onlinedirectories_view,
  },
  {
    to: "/utilitiestabs/CustomReport",
    component: CustomReport,
    label: (
      <div>
        <div className="text-left"> Custom Report </div>
      </div>
    ),
    icon: <DocumentTextIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_customreport_view,
  },
  {
    to: ROUTE_PATHS.Utilities_VendorConfiguration_Autopay_Index,
    component: VendorConfiguration,
    label: (
      <div>
        <div className="truncate text-left"> Vendor Configuration </div>
      </div>
    ),
    icon: <DocumentTextIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_utilities_autopay_view,
  },
  {
    to: ROUTE_PATHS.Utilities_OfficeAppliancesConfiguration_Index,
    icon: <BuildingStorefrontIcon className="h-4 w-4 mr-2" />,
    title: "OfficeAppliances",
    label: (
      <div>
        <div className="truncate text-left">Office Appliances</div>
      </div>
    ),

    component: OfficeAppliances,
    permission: PERMISSIONS.permission_utilities_officeappliances_view,
  },
];
